import axios from 'axios';

const getApiBaseURL = 'https://svod.polyanaski.ru/get';
const getApi = axios.create({
    baseURL: getApiBaseURL
});

export {getApiBaseURL, getApi};